import { render } from "./shortcode_course_table.vue?vue&type=template&id=c21e69ca"
import script from "./shortcode_course_table.vue?vue&type=script&lang=js"
export * from "./shortcode_course_table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__